import { CultureInfo } from '../culture-info.model';
import { CultureInfoShi } from './shi';

/**
 * @ignore
 */
export const CultureInfoShiLatn: CultureInfo = {
  name: 'shi-Latn',
  displayName: 'Tashelḥiyt',
  iso3LanguageCode: 'shi',
  iso2LanguageCode: 'shi',
  ietfLanguageTag: 'shi-Latn',
  parent: CultureInfoShi
};
